import { Icon } from '@tkww/orion-web-ds-graphic';
import { Body1 } from '@xo-union/tk-ui-typography';
import React, { type FC } from 'react';
import Styles from './Faq.scss';

interface Props {
	text: 'Reception' | 'Ceremony' | 'Bar service' | 'Catering';
	value: string | null;
	iconName: 'champagne-glass' | 'rounded-altar' | 'glass' | 'cutlery';
}

export const Faq: FC<Props> = ({ text, iconName, value }) => {
	return (
		<div className={Styles.faq}>
			<div className={Styles.circle}>
				<Icon
					name={iconName}
					size="lg"
					aria-label={undefined}
					aria-hidden={true}
				/>
			</div>
			<div className={Styles.details}>
				<Body1>{text}:</Body1>
				<Body1 bold>{value}</Body1>
			</div>
		</div>
	);
};
